export enum PosEnum {
  ENCOMPASS = 'Encompass',
  ALE = 'ALE',
}
